import React from 'react';
import { Lightbulb } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface TimeAllocation {
  year: string;
  ourIp: number;
  ipOpportunity: number;
  other: number;
  ourIpProjects: string[];
  ipOpportunityProjects: string[];
  otherProjects: string[];
}

interface ProjectTypeAllocationChartProps {
  data: TimeAllocation[];
}

export function ProjectTypeAllocationChart({ data }: ProjectTypeAllocationChartProps) {
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-100">
          <p className="font-medium text-gray-900 mb-2">Year {label}</p>
          {payload.map((entry: any) => {
            let projects: string[] = [];
            if (entry.name === 'Our IP') {
              projects = data.find(d => d.year === label)?.ourIpProjects || [];
            } else if (entry.name === 'IP Opportunity') {
              projects = data.find(d => d.year === label)?.ipOpportunityProjects || [];
            } else {
              projects = data.find(d => d.year === label)?.otherProjects || [];
            }

            return (
              <div key={entry.name} className="mb-2 last:mb-0">
                <p className="text-sm font-medium" style={{ color: entry.color }}>
                  {entry.name} ({Math.round(entry.value * 100)}%)
                </p>
                {projects.length > 0 ? (
                  <ul className="text-sm text-gray-600 mt-1">
                    {projects.map((project, index) => (
                      <li key={index}>• {project}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-gray-500 mt-1">No projects</p>
                )}
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <div className="flex items-center mb-4">
        <Lightbulb className="w-5 h-5 text-indigo-600 mr-2" />
        <h2 className="text-xl font-semibold text-gray-800">Time Allocation by Project Type</h2>
      </div>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            stackOffset="expand"
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="year"
              tick={{ fill: '#6B7280', fontSize: 12 }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <YAxis
              tickFormatter={(value) => `${Math.round(value * 100)}%`}
              tick={{ fill: '#6B7280', fontSize: 12 }}
              axisLine={{ stroke: '#E5E7EB' }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey="ourIp"
              stackId="a"
              name="Our IP"
              fill="#8B5CF6"
            />
            <Bar
              dataKey="ipOpportunity"
              stackId="a"
              name="IP Opportunity"
              fill="#F59E0B"
            />
            <Bar
              dataKey="other"
              stackId="a"
              name="Client Projects"
              fill="#D1D5DB"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}